import {
  Modal,
  Form,
  Input,
  Button,
  Radio,
  Select,
  Tabs,
  Row,
  Col,
  message,
} from "antd";
import React, { useCallback, useEffect, useRef, useState } from "react";
import _ from "lodash";
import IntlMessage from "../../../components/IntlMessage";
import userOperatorApi from "../../../api/user-operator";
import paymentMethodApi from "../../../api/paymentMethod";
import CountryData from "../../../utils/countrydata";
import customersApi from "../../../api/customers";
import { useSelector } from "react-redux";

const CustomerForm = (props) => {
  const { isModalOpen, setOpenModal, currentData, onModalClose, onRefresh } =
    props;
  const [paymentOption, setPaymentOption] = useState([]);
  const [loading, setLoading] = useState(false);
  const isMounted = useRef(null);
  const operator = useSelector((state) => state.auth.operator);

  const isMobile = window.innerWidth < 576;
  const fetch = useCallback(async () => {
    try {
      if (isMounted) {
        const filter = {
          page: 1,
          limit: 9999,
          order_by: "id",
          order_dir: "DESC",
          keyword: "",
        };
        const payment = await paymentMethodApi.getAll(filter);

        const list_payment = payment.data.map((item) => {
          return {
            label: item.display || item.id,
            value: item.id,
          };
        });
        setPaymentOption(list_payment);
      }
    } catch (err) {
      console.log(err);
    }
  }, [isMounted]);

  useEffect(() => {
    isMounted.current = true;
    fetch();
  }, [fetch, loading]);

  const initialValues = {
    ...currentData,
    status: currentData && currentData.status ? 1 : 0,
    is_on_userapp: currentData && currentData.is_on_userapp ? 1 : 0,
    is_on_operatorapp: currentData && currentData.is_on_operatorapp ? 1 : 0,
    fee: currentData && currentData.fee ? currentData.fee : "",
  };

  const onFinish = (values) => {
    console.log("Success:", values);
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const layout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 18 },
  };

  const [form] = Form.useForm();

  const handleOk = async () => {
    form
      .validateFields()
      .then(async (values) => {
        if (operator) {
          values.operator = operator?.id;
        }
        if (currentData) {
          const res = await customersApi.update(currentData?.id, values);
          if (res) {
            message.success("Update customer successfully");
            setLoading(true);
            setOpenModal(false);
            onRefresh();
          } else {
            throw new Error("Update customer failed");
          }
        } else {
          const res = await customersApi.create(values);
          if (res) {
            message.success("Create customer successfully");
            setLoading(true);
            setOpenModal(false);
            onRefresh();
          } else {
            throw new Error("Create customer failed");
          }
        }
      })
      .catch((info) => {
        console.log("Validate Failed:", info);
      });
  };

  return (
    <React.Fragment>
      <Modal
        title={
          currentData ? (
            <IntlMessage id="global.edit" />
          ) : (
            <IntlMessage id="global.add" />
          )
        }
        open={isModalOpen}
        onCancel={onModalClose}
        width={isMobile ? "90%" : "50%"}
        footer={[
          <>
            <Button key="back" type="default" onClick={onModalClose}>
              {<IntlMessage id="global.cancel" />}
            </Button>
            <Button key="back" type="primary" onClick={handleOk}>
              {<IntlMessage id="global.save" />}
            </Button>
          </>,
        ]}
      >
        <Form
          name="basic"
          labelAlign="left"
          {...layout}
          className="ml-20"
          initialValues={initialValues}
          form={form}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          <Form.Item label="First name" name="firstname">
            <Input />
          </Form.Item>
          <Form.Item label="Last name" name="lastname">
            <Input />
          </Form.Item>
          <Form.Item
            label={<IntlMessage id="global.phone_code" />}
            name={"phone_code"}
            initialValue={"+221"}
          >
            <Select
              style={{ width: "100%" }}
              placeholder="Select phone code"
              showSearch
              defaultValue={`+221`}
              options={CountryData.map((country, i) => {
                return {
                  label: `(+${country.code}) ${country.country}`,
                  value: `+${country.code}`,
                };
              })}
            />
          </Form.Item>
          <Form.Item label="Phone" name="mobile">
            <Input />
          </Form.Item>
        </Form>
      </Modal>
    </React.Fragment>
  );
};

export default CustomerForm;
